<template>
	<h2>Página de Contacto</h2>
</template>

<script>
export default {
	name: 'ContactoComponent',
};
</script>
